import { render } from "./Preference.vue?vue&type=template&id=748fe7c9&scoped=true"
import script from "./Preference.vue?vue&type=script&lang=js"
export * from "./Preference.vue?vue&type=script&lang=js"

import "./Preference.vue?vue&type=style&index=0&id=748fe7c9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-748fe7c9"

export default script